/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
import { ChangeDetectionStrategy, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';

import { ToastMessageService } from '@fitness-force/api';

import { AppErrors, ErrorMsgComponent } from '@fitness-force/errors';
import { CancelClientSubscriptionFreezeRequest, ClientSubscriptionFreezeResponse } from '@fitness-force/models';
import { FreezeService } from '@fitness-force/api';
import { COMPANY_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { ErrorsComponent,} from '@fitness-force/common/errors'

import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'freeze-cancel',
  templateUrl: './freeze-cancel.component.html',
  styleUrls: ['./freeze-cancel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    DatePickerModule,
    SelectModule,
    StyleClassModule,
    ButtonModule,
    PopoverModule,
    AvatarModule,
    ErrorMsgComponent,
    ErrorsComponent,
    TranslateModule
  ]
})
export class FreezeCancelComponent implements OnInit {
  @Input('visible') visible = false;
  @Input('freeze') freeze$: BehaviorSubject<ClientSubscriptionFreezeResponse | null> = new BehaviorSubject<ClientSubscriptionFreezeResponse | null>(null);

  @Output('hidePopup') hidePopup = new EventEmitter<boolean>();

  fg: UntypedFormGroup;
  isUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  //#region error popup
  error = new BehaviorSubject(null as AppErrors | null);
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
    this.error.next(null);
  }
  //#endregion error popup

  constructor(
    private freezeService: FreezeService,
    private translate: TranslateService,
    private store: Store,
    private fb: UntypedFormBuilder,
    private toastMessageService: ToastMessageService,
  ) {
    this.fg = this.fb.group({
      reason: new UntypedFormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }

  get ReasonControl(): AbstractControl | null {
    return this.fg.controls.reason as AbstractControl;
  }

  HidePopup() {
    this.hidePopup.emit(this.isUpdated$.value);
    this.visible = false;
  }

  CancelFreeze(): void {
    this.fg.markAllAsTouched();
    if (this.fg.valid) {
      let param = {} as CancelClientSubscriptionFreezeRequest;
      param.cancelled_reason = this.ReasonControl?.value;

      this.freezeService.PostCancelFreeze(
        environment.BASE_URL,
        this.freeze$.value?.tenant_id || 0,
        this.freeze$.value?.client_id || 0,
        this.freeze$.value?.client_subscription.id || 0,
        this.freeze$.value?.freeze_id || 0,
        param
      ).subscribe({
        next: (res) => {
          if (res) {
            this.translate.get('FREEZE.FREEZE_CANCEL.REQUEST_SUCCESS').subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          }

          this.isUpdated$.next(true);

          setTimeout(() => { this.HidePopup(); }, 3000);
        },
        error: (err) => {
          this.error.next(err);
          this.showErrorPopup.next(true);
        }
      });
    }
  }
}
